
import { Component, Vue } from "vue-property-decorator";
import UIkit from "uikit";
import AuthService from "@/services/auth_service";
import { Roles } from "@/models/user";

@Component
export default class LoginView extends Vue {
  protected email = "";
  protected password = "";
  protected loading = false;
  protected notice = "";
  private authService = new AuthService();

  created(): void {
    // Surface the "admins only" / "please sign in" message passed by the guard.
    this.notice = (this.$route.query.notice as string) || "";
  }

  get portalUrl(): string {
    const login = process.env.VUE_APP_LOGIN_URL;
    if (!login) return "";
    const redirect = (this.$route.query.redirect as string) || "/";
    const returnUrl = `${process.env.VUE_APP_URL || ""}${redirect}`;
    return `${login}?returnURL=${encodeURIComponent(returnUrl)}`;
  }

  protected async onSubmit(): Promise<void> {
    this.loading = true;
    this.notice = "";
    try {
      const user = await this.authService.login(this.email, this.password);
      if (user.role !== Roles.Admin) {
        await this.$store.dispatch("clearAuth");
        try {
          await this.authService.logout();
        } catch (e) {
          // ignore — best effort
        }
        this.notice = "This tool is restricted to admins only.";
        UIkit.notification({ message: "Admins only.", status: "danger" });
        return;
      }
      await this.$store.dispatch("setAuth", user);
      const redirect = (this.$route.query.redirect as string) || "/";
      this.$router.push(redirect).catch(() => undefined);
    } catch (err: any) {
      const msg =
        err?.response?.data?.message || "Invalid email or password.";
      this.notice = msg;
      UIkit.notification({ message: msg, status: "danger" });
    } finally {
      this.loading = false;
    }
  }
}
